import { Table as MUITable, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { DialogButton } from 'components/DialogButton/DialogButton';
import { LogsDialog } from 'components/Dialogs';
import strings, { url } from 'constants/index';
import { UTCDateFormat } from 'utils/formatter.utils';

export interface ChangesData {
  action: string;
  logBy: string;
  propertyName?: string;
  oldValue?: string;
  currentValue?: string;
}

export const formatProperty = (property: ChangesData) => {
  const formatted = UTCDateFormat(property, true);
  const metaString = /^(MetadataProperties||metadataProperties)\d./;
  if (metaString.test(formatted.propertyName)) {
    formatted.propertyName = formatted.propertyName.replace(metaString, '');
  }

  switch (property.action) {
    case strings.created:
    case strings.removed:
      formatted.oldValue = formatted.oldValue || strings.not_applicable;
      formatted.currentValue = formatted.currentValue || strings.not_applicable;
      return formatted;
    default:
      return formatted;
  }
};

export const ChangesDataTable = ({ tableRowKeyPrefix, changeDataItems }) => (
  <MUITable>
    <TableHead>
      <TableRow>
        <TableCell align="left">{strings.action}</TableCell>
        <TableCell align="left">{strings.property_name}</TableCell>
        <TableCell align="left">{strings.old_value}</TableCell>
        <TableCell align="left">{strings.current_value}</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {changeDataItems?.map(change => {
        const formattedChange = formatProperty(change);

        return (
          <TableRow
            key={`${tableRowKeyPrefix}-${formattedChange?.propertyName}-${formattedChange?.currentValue}`}
          >
            <TableCell>{formattedChange?.action}</TableCell>
            <TableCell>{formattedChange?.propertyName}</TableCell>
            <TableCell>{formattedChange?.oldValue}</TableCell>
            <TableCell>
              {formattedChange.propertyName === 'DeletedOldFixtureId' ? (
                <DialogButton
                  data-testid="logs"
                  label={formattedChange?.currentValue}
                  dialog={LogsDialog}
                  variant="text"
                  disableRipple
                  dialogProps={{
                    entityName: `${formattedChange?.propertyName} - ${formattedChange?.currentValue}`,
                    logsUrl: `${url.fixtures}/${formattedChange?.currentValue}${url.logs}`,
                  }}
                  sx={{
                    fontSize: '0.875rem',
                    fontWeight: 'fontWeightRegular',
                    padding: 0,
                    justifyContent: 'left',
                    color: '#00008F',
                    '&:hover': {
                      textDecoration: 'underline',
                      backgroundColor: 'transparent',
                    },
                  }}
                />
              ) : (
                formattedChange?.currentValue
              )}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  </MUITable>
);
